import { api, resolvePagination } from './api';

/**
 * Retrieve patient groups with pagination.
 */
export const getGroupsPagination = async (pageLimit, pageToken, status) => {
    const headers = {
        ...resolvePagination(pageToken, pageLimit),
        'CHEART-QUERY-STATUS': String(status)
    };
    return api.get('/cheart/groups', { headers });
};

/**
 * Retrieve patient groups.
 */
export const getGroups = async () => {
    const response = await api.get('/cheart/groups');
    return response.data;
};

/**
 * Retrieve patient groups of the user with pagination.
 */
export const getUserGroupsPagination = async (uuid, pageLimit, pageToken, status) => {
    const headers = {
        ...resolvePagination(pageToken, pageLimit),
        'CHEART-QUERY-STATUS': String(status)
    };
    return api.post('/cheart/user/groups', { uuid }, { headers });
};

/**
 * Retrieve patient groups of the user.
 * @param {string} uuid - The role UUID of the user.
 */
export const getUserGroups = async (uuid) => {
    const response = await api.post('/cheart/user/groups', { uuid });
    return response.data;
};

/**
 * Retrieve patient group by UUID.
 * @param {string} uuid - The role UUID of the group to fetch.
 */
export const fetchGroupByUUID = async (uuid) => {
    const response = await api.post('/cheart/groups/fetch', { uuid });
    return response.data;
};

/**
 * Edit patient group details.
 * @param {object} groupData
 */
export const patchGroupData = async (groupData) => {
    const response = await api.patch('/cheart/groups', groupData);
    return response.data;
};

/**
 * Create patient group.
 * @param {object} groupData
 */
export const createGroup = async (groupData) => {
    const response = await api.post('/cheart/groups', groupData);
    return response.data;
};

/**
 * Delete (disable) a ConnectedHeart Group.
 * @param {string} uuid - The unique identifier of the group to delete.
 */
export const deleteGroup = async (uuid) => {
    const response = await api.delete('/cheart/groups', {
        data: { uuid }
    });
    return response.data;
};

/**
 * Add or remove roles to patient group.
 * @param {string} uuid - The unique identifier of the group to update.
 * @param {Array} [to_add=[]] - An array of Roles to add to the group.
 * @param {Array} to_remove - An array of Roles to remove to the group.
 */
export const updateGroupRoles = async ({ uuid, to_add = [], to_remove = [] }) => {
    const response = await api.put('/cheart/groups', { uuid, to_add, to_remove });
    return response.data;
};
